import { Outlet, useLocation } from "react-router";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Seo } from "./Seo";
import { getSiteOrigin } from "../site";
import { seoCityLandingPages } from "../local-pages";

function PublicSeo() {
  const location = useLocation();
  const { pathname } = location;

  if (pathname.startsWith("/blog")) {
    return null;
  }

  const defaultMetadata = {
    title: "Professionelle Website für kleine Unternehmen",
    description:
      "mutzur erstellt professionelle Websites für kleine Unternehmen mit klarer Preisstruktur, Hosting, Wartung und laufendem Support.",
    noIndex: false,
    keywords: [
      "website kleine unternehmen",
      "professionelle website",
      "website erstellen lassen",
      "webdesign für unternehmen",
    ],
  };

  const routeMetadata = [
    {
      match: pathname === "/",
      title: "Professionelle Website für kleine Unternehmen | Festpreis ab 500 Euro",
      description:
        "Professionelle Website für kleine Unternehmen: 500 Euro Setup plus 99 Euro monatlich für Hosting, Wartung, Sicherheit und Support.",
      keywords: [
        "professionelle website kleine unternehmen",
        "website festpreis",
        "website 500 euro",
        "website erstellen lassen kleine unternehmen",
      ],
    },
    {
      match: pathname === "/angebot",
      title: "Website Leistungen für kleine Unternehmen | Angebot",
      description:
        "Leistungsumfang, Preisstruktur und Ablauf für professionelle Websites für kleine Unternehmen.",
      keywords: [
        "website leistungen",
        "website angebot kleine unternehmen",
        "webdesign leistungen",
        "website service",
      ],
    },
    {
      match: pathname === "/ablauf",
      title: "Website erstellen lassen | Ablauf bis zum Livegang",
      description:
        "So läuft die Website-Erstellung ab: vom Fragebogen über den Entwurf bis zum Livegang und der laufenden Betreuung.",
      keywords: [
        "website erstellen lassen ablauf",
        "webdesign ablauf",
        "website projekt ablauf",
      ],
    },
    {
      match: pathname === "/preise",
      title: "Website Preise für kleine Unternehmen | 500 Euro plus Betreuung",
      description:
        "Transparente Website Preise für kleine Unternehmen: 500 Euro einmalig plus 99 Euro monatlich für Hosting, Wartung und Support.",
      keywords: [
        "website preise kleine unternehmen",
        "website kosten",
        "webdesign preise",
        "website festpreis",
      ],
    },
    {
      match: pathname === "/softwareentwicklung",
      title: "Individuelle Softwareentwicklung für Unternehmen",
      description:
        "Individuelle Softwareentwicklung für Unternehmen, die mehr als eine klassische Website benötigen.",
      keywords: [
        "softwareentwicklung unternehmen",
        "individuelle softwareentwicklung",
        "webanwendung entwickeln lassen",
      ],
    },
    {
      match: pathname === "/standorte",
      title: "Webdesign in Dresden, Senftenberg und Umgebung | Standorte",
      description:
        "Lokale Landingpages für Webdesign und Website-Erstellung in Dresden, Senftenberg, Hoyerswerda, Meißen, Ruhland und Schwarzheide.",
      keywords: [
        "webdesign dresden",
        "webdesign senftenberg",
        "webdesign hoyerswerda",
        "website erstellen lassen dresden",
      ],
    },
    ...seoCityLandingPages.map(({ citySlug, city, variant }) => ({
      match: pathname ===
        (variant === "website-erstellen-lassen"
          ? `/website-erstellen-lassen-${citySlug}`
          : variant === "webdesigner"
            ? `/webdesigner-${citySlug}`
            : `/webdesign-${citySlug}`),
      title:
        variant === "website-erstellen-lassen"
          ? `Website erstellen lassen ${city}`
          : variant === "webdesigner"
            ? `Webdesigner ${city}`
            : `Webdesign ${city}`,
      description:
        variant === "website-erstellen-lassen"
          ? `Website erstellen lassen in ${city} mit Hosting, Wartung und laufender Betreuung durch mutzur.`
          : variant === "webdesigner"
            ? `Webdesigner in ${city} für Unternehmen mit Hosting, Wartung und laufender Betreuung.`
            : `Professionelles Webdesign für Unternehmen in ${city} mit Hosting, Wartung und laufender Betreuung.`,
    })),
    {
      match: pathname === "/impressum",
      title: "Impressum",
      description: "Anbieterkennzeichnung und Kontaktdaten von mutzur.",
    },
    {
      match: pathname === "/datenschutz",
      title: "Datenschutz",
      description: "Datenschutzhinweise für die Website von mutzur.",
    },
    {
      match: pathname === "/agb",
      title: "AGB",
      description: "Allgemeine Geschäftsbedingungen von mutzur.",
    },
    {
      match: pathname === "/widerruf",
      title: "Widerruf",
      description: "Informationen zum Widerrufsrecht bei mutzur.",
    },
    {
      match: pathname.startsWith("/fragebogen"),
      title: "Fragebogen",
      description: "Projektfragebogen für die Website-Anfrage bei mutzur.",
      noIndex: true,
    },
    {
      match: pathname.startsWith("/konto-aktivieren"),
      title: "Konto aktivieren",
      description: "Kontoaktivierung für den Kundenbereich von mutzur.",
      noIndex: true,
    },
    {
      match: pathname.startsWith("/bestellung-erfolgreich"),
      title: "Bestellung erfolgreich",
      description: "Statusseite für abgeschlossene Bestellungen bei mutzur.",
      noIndex: true,
    },
  ].find((entry) => entry.match);

  const metadata = routeMetadata ?? defaultMetadata;

  return (
    <Seo
      title={metadata.title}
      description={metadata.description}
      path={pathname}
      keywords={metadata.keywords}
      noIndex={metadata.noIndex}
      structuredData={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "mutzur",
        url: getSiteOrigin(),
      }}
    />
  );
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicSeo />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
